import {BaseRectangle} from './BaseRectangle';

const DEFAULT_OPTIONS = {
  border: {
    lineWidth: '1',
    color: 'red'
  }
};

/**
 * This clears a rectangle-shaped area on a canvas. Useful for emptying part of a canvas (e.g. with a background).
 */
export class ClearRectangle extends BaseRectangle {
  constructor (x, y, w, h, options = DEFAULT_OPTIONS) {
    super(x, y, w, h, options);
  }

  paint (ctx, x, y, w, h) {
    ctx.clearRect(x, y, w, h);

    if (this._options.border) {
      ctx.beginPath();
      ctx.lineWidth = this._options.border.lineWidth;
      ctx.strokeStyle = this._options.border.color;
      ctx.rect(x, y, w, h);
      ctx.stroke();
    }
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/shapes/ClearRectangle.js